<template>
  <div
    :class="cssClasses">
    <span class="day-number">
      {{ dayNumber }}
    </span>
    <br>
    <f-badge
      v-if="itemData"
      pill
      class="day-info">
      {{ itemData.length }}

      <span
        v-if="itemData"
        class="for-desktop">
        {{ $tc('calendar.meeting', itemData.length) }}
      </span>
    </f-badge>
  </div>
</template>
<script>

export default {
  name: 'f-calendar-day',
  props: [
    'itemData',
    'dayData',
    'isCurrentDay'
  ],
  computed: {
    isPastDay () {
      if (this.dayData.isToday) {
        return false;
      }

      let dateParts = this.dayData.date.split('-').map(n => parseInt(n, 10));
      let dateObject = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
      let today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setMilliseconds(0);

      if (dateObject < today) {
        return true;
      }

      return false;
    },
    cssClasses () {
      if (this.dayData) {
        return {
          'day': true,
          'is-today': this.dayData.isToday,
          'is-different-month': !this.dayData.isCurrentMonth,
          'is-past': this.isPastDay
        };
      }

      return {
        'day': true,
        'is-current': this.isCurrentDay
      };
    },
    dayNumber () {
      if (this.dayData) {
        return this.dayData.number;
      }

      if (!this.itemData) {
        return '-';
      }

      return parseInt(this.itemData.date.split('-')[2], 10);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.day {
  border-right: 1px solid $color-border;
  border-bottom: 1px solid $color-border;
  cursor: pointer;
  height: 110px;
  padding: 1rem;
  position: relative;
  width: calc(100% / 7);

  &.is-today:nth-child(7n - 1) {
    background: repeating-linear-gradient(45deg, $color-green-light, $color-green-light 20px, $color-light 0, $color-light 40px);
  }

  &.is-today:nth-child(7n) {
    background: repeating-linear-gradient(45deg, $color-green-light, $color-green-light 20px, $color-light 0, $color-light 40px);
    border-right: none;
  }


  &:nth-child(7n - 1) {
    background: repeating-linear-gradient(45deg, $color-border, $color-border 20px, $color-light 0, $color-light 40px);
  }

  &:nth-child(7n) {
    background: repeating-linear-gradient(45deg, $color-border, $color-border 20px, $color-light 0, $color-light 40px);
    border-right: none;
  }

  &:hover {
    background: $color-bg-checked;

    &:before {
      border: 2px solid $color-primary;
      border-radius: 4px;
      content: "";
      height: calc(100% + 6px);
      position: absolute;
      pointer-events: none;
      right: -3px;
      top: -3px;
      width: calc(100% + 6px);
      z-index: 1;
    }
  }

  .day-info {
    margin: 10px auto 5px auto;
    min-width: 22px;
  }
  &.is-today {
    background: $color-green-light;
  }

  &.is-current {
    background: $color-primary;
    border-color: $color-primary;
    color: #CACEDB;

    &:after {
      border: 10px solid $color-primary;
      border-top-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      content: "";
      left: calc(50% - 10px);
      position: absolute;
      top: -20px;
    }
  }

  &.is-different-month {
    background: $color-bg-grey-light;
    opacity: .5;
  }

  &.is-past {
    & > * {
      opacity: .35;
    }
  }

  &-number {
    font-size: var(--font-size-medium);
  }

  &-closed {
    bottom: 1.8rem;
    color: $color-red;
    font-size: 1.3rem;
    font-weight: bold;
    opacity: .75;
    position: absolute;
    right: 1rem;
  }

  &-minimal {
    height: 64px;
    padding: .5rem;

    .day-info.f-badge {
      border-radius: 50%;
      line-height: $font-line-height-tiny;
      padding: 5px;
      margin-top: 0px;
      text-align: center;
    }

    .for-desktop {
      display: none!important;
    }
  }
}

@media (max-width: 1240px) {
  .day {
    padding: 0.9rem;
  }
}

@media (max-width: 960px) {
  .day {
    height: 90px;
    padding: .5rem 1rem;

    &-minimal {
      height: 64px;
    }

    &-info.f-badge {
      border-radius: 50%;
    }
  }

  .for-desktop {
    display: none!important;
  }
}

@media screen and (max-width: 768px) {
  .day-number {
    font-size: var(--font-size-base);
  }
}

@media (max-width: 640px) {
  .day {
    height: 64px;
    padding: .25rem .5rem;

    &-number {
      font-size: var(--font-size-small);
    }

    .day-info {
      margin-top: 0px;
    }
  }
}
</style>
